/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Details/Office/Zip",
  isInvalid,
  onChange
  
}) {
let newProfessionalOtherExternalOfficePostalAddressZipValueData = fromData.useDataValue({ viewPath,
context: 'new_professional',
path: 'other.external_office.postal_address.zip',
})
let newProfessionalOtherExternalOfficePostalAddressZipIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_professional',
path: 'other.external_office.postal_address.zip',
validate: fromValidate.zip,
})
let newProfessionalOtherExternalOfficePostalAddressZipChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'other.external_office.postal_address.zip',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_professional.other.external_office.postal_address.zip"
 validate="/Data/validate.js zip"
 invalid={!newProfessionalOtherExternalOfficePostalAddressZipIsValidData}
 value={newProfessionalOtherExternalOfficePostalAddressZipValueData}
 onChange={newProfessionalOtherExternalOfficePostalAddressZipChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="ZIP Code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}